export const NOT_FOUND_IMAGE =
  'https://images-static.nykaa.com/uploads/3e28e814-3166-4b38-982c-f8897909f304.jpg?tr=w-600,cm-pad_resize';
export const NOT_FOUND_IMAGE_V2 =
  'https://images-static.nykaa.com/media/PageNotFound.jpg?tr=w-600,cm-pad_resize';
export const POPULAR_BRAND = 'popular-brands';
export const POPULAR_BRNAD2 = 'popular-brands2';
export const FETCH_ERROR = 'Error in Fetch Widgets service';
export const FETCH_ACTION_ERROR = 'Error in Fetch Widgets action';
